module.exports = __webpack_public_path__ + "cde57bee53ae55ab69be0b25e6f0334c.png";